import { manufacturingFetch } from "@/lib/manufacturingClient";
import { forgetQcChecklist } from "@/lib/manufacturing/builderAssistantChecklistClient";

function post<T>(body: Record<string, unknown>) {
  forgetQcChecklist();
  return manufacturingFetch<T>("/api/mfg/builder-assistant", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export function setQcItemFailureNote(itemId: string, required: boolean) {
  return post<{ ok: true }>({ op: "checklist-audit-item-note", item_id: itemId, required });
}

export function reorderQcChecklist(kind: "category" | "item", ids: string[]) {
  return post<{ ok: true }>({ op: "checklist-reorder", kind, ids });
}

export function renameQcChecklistCategory(categoryId: string, name: string) {
  return post<{ ok: true }>({ op: "checklist-rename-category", category_id: categoryId, name });
}

export function renameQcChecklistItem(itemId: string, title: string, description: string) {
  return post<{ ok: true }>({ op: "checklist-rename-item", item_id: itemId, title, description });
}

export function moveQcChecklistItem(itemId: string, categoryId: string, newCategoryName = "") {
  return post<{ ok: true; category_id: string }>({
    op: "checklist-move-item",
    item_id: itemId,
    category_id: categoryId,
    new_category_name: newCategoryName,
  });
}
